import FarloUiLightbox from './vendors/farlo-ui-lightbox';
import { farloUiCrmSignup } from './components/footer/farloUiCrmSignup.js';
import FarloUiSelectBox from './vendors/farlo-ui-selectbox';
import FarloUiRevolverCarousel from './vendors/farlo-ui-revolver-carousel';
import FarloUiTicketCalendar from './vendors/farlo-ui-ticket-calendar';

((document, window, history) => {
	const pushState = history.pushState;
	const youTubeRegex = RegExp(/(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i);

	// cookie compliance banner
	function cookieCompliance() {
		if (document.querySelector('.site-farlo-ui-biscuit-banner__button')) {
			document.querySelector('.site-farlo-ui-biscuit-banner__button').addEventListener('click', (e) => {
				e.preventDefault();

				e.target.closest('.site-farlo-ui-biscuit-banner').classList.add('site-farlo-ui-biscuit-banner--hide');

				window._farlo.storage.set('cookieCompliance', 'true', 'cookie');
			});
		}

		if (document.querySelector('.site-farlo-ui-biscuit-banner__button--close')) {
			document.querySelector('.site-farlo-ui-biscuit-banner__button--close').addEventListener('click', (e) => {
				e.preventDefault();

				e.target.closest('.site-farlo-ui-biscuit-banner').classList.add('site-farlo-ui-biscuit-banner--hide');
			});
		}
	}

	// default navicon
	function navicon() {
		document.querySelector('.site-navigation__navicon').addEventListener('click', (e) => {
			e.preventDefault();
			e.currentTarget.classList.toggle('site-navigation__navicon--active');
			document.querySelector('.site-navigation-container').classList.toggle('site-navigation-container--active');
			document.body.classList.toggle('site-navigation--open');
		});
	}

	// default navigation subnav
	function navigation(submenu) {
		if (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0)) {
			window._farlo.helpers.getSiblings(submenu)[ 0 ].addEventListener('click', (e) => {
				if (!e.target.classList.contains('site-navigation__menu-item--active')) {
					e.preventDefault();

					e.currentTarget.classList.add('site-navigation__menu-item--active');
					submenu.classList.add('site-navigation__sub-menu--active');

					for (let i = 0; i < window._farlo.helpers.getSiblings(e.currentTarget.parentNode).length; i += 1) {
						if (window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 0 ] && window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 0 ].classList.contains('site-navigation__menu-item--active')) {
							window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 0 ].classList.remove('site-navigation__menu-item--active');
						}

						if (window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 1 ] && window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 1 ].classList.contains('site-navigation__sub-menu--active')) {
							window._farlo.helpers.getSiblings(e.currentTarget.parentNode)[ i ].children[ 1 ].classList.remove('site-navigation__sub-menu--active');
						}
					}
				} else {
					return true;
				}
			});
		} else {
			submenu.parentNode.addEventListener('mouseover', () => {
				if (submenu.parentNode.querySelector('.site-navigation__sub-menu--active')) {
					submenu.parentNode.querySelectorAll('.site-navigation__sub-menu--active').forEach((_sel) => {
						_sel.classList.remove('site-navigation__sub-menu--active');
						_sel.parentNode.classList.remove('site-navigation__menu-item--active');
					});
				}
				submenu.classList.add('site-navigation__sub-menu--active');
				submenu.parentNode.classList.add('site-navigation__menu-item--active');
			});

			submenu.parentNode.addEventListener('mouseout', () => {
				submenu.classList.remove('site-navigation__sub-menu--active');
				submenu.parentNode.classList.remove('site-navigation__menu-item--active');
			});
		}
	}

	// function farloUiCrmSignup(_sel) {
	// 	let farloUiSignupForm = null;

	// 	if (typeof _sel.target !== 'undefined' && _sel.target !== null) {
	// 		if (_sel.target.dataset.crmButtonFor !== '') {
	// 			farloUiSignupForm = new FarloUiMc(_sel.target.dataset.crmButtonFor);
	// 		}
	// 	} else if (farloUiSignupForm) {
	// 		farloUiSignupForm.toggleForm();
	// 	} else {
	// 		farloUiSignupForm = new FarloUiMc(_sel.id);
	// 	}
	// }

	function faqs() {
		const accordions = document.querySelectorAll('.site-faqs__accordion-faq');

		const openAccordion = (accordion) => {
			const answer = accordion.querySelector('.site-faqs__accordion-answer');
			accordion.classList.add('site-faqs__accordion-faq--active');
			answer.style.maxHeight = answer.scrollHeight + 'px';
		};

		const closeAccordion = (accordion) => {
			const answer = accordion.querySelector('.site-faqs__accordion-answer');
			accordion.classList.remove('site-faqs__accordion-faq--active');
			answer.style.maxHeight = null;
		};

		accordions.forEach((accordion) => {
			const question = accordion.querySelector('.site-faqs__accordion-question');
			const answer = accordion.querySelector('.site-faqs__accordion-answer');

			question.onclick = () => {
				if (answer.style.maxHeight) {
					closeAccordion(accordion);
				} else {
					accordions.forEach((acc) => closeAccordion(acc));
					openAccordion(accordion);
				}
			};
		});
	}

	function smoothScroll(_sel) {
		_sel.addEventListener('click', function(e) {
			e.preventDefault();

			if (document.querySelector('.site-navigation__navicon--active') && document.body.classList.contains('site-navigation--open')) {
				document.querySelector('.site-navigation__navicon').click();
			}

			if (e.target.parentNode.parentNode) {
				e.target.parentNode.parentNode.classList.remove('site-navigation__sub-menu--active');
			}

			if (e.target.parentNode.parentNode.parentNode) {
				e.target.parentNode.parentNode.parentNode.querySelector('a').classList.remove('site-navigation__menu-item--active');
			}

			if (e.target.href.includes('#') && document.getElementById(e.target.href.split('#')[ 1 ])) {
				document.getElementById(e.target.href.split('#')[ 1 ]).scrollIntoView({ behavior: 'smooth' });
			} else {
				window.location.href = e.target.href;
			}
		});
	}

	function parallaxSections() {
		const sections = document.querySelectorAll('.site-parallax-section');
		const header = document.querySelector('.site-header');

		const resetStyles = () => {
			sections.forEach((section) => {
				const image = section.querySelector('.site-parallax-section__image');
				const text = section.querySelector('.site-parallax-section__text');
				image.style.transform = '';
				text.style.transform = '';
			});
		};

		const updateParallax = () => {
			if (window.innerWidth <= 980) {
				resetStyles(); // Reset styles on smaller screens
				return; // Disable parallax effect for screens narrower than 980px
			}

			const headerHeight = header.offsetHeight; // Get the dynamic height of the header

			sections.forEach((section) => {
				const image = section.querySelector('.site-parallax-section__image');
				const text = section.querySelector('.site-parallax-section__text');

				const sectionRect = section.getBoundingClientRect();
				const sectionTop = window.scrollY + sectionRect.top;
				const textHeight = text.offsetHeight;
				const imageHeight = image.offsetHeight;

				const scrollPosition = window.scrollY;
				const relativeScroll = (scrollPosition - sectionTop) + headerHeight;

				if (textHeight > imageHeight && relativeScroll >= 0 && scrollPosition <= sectionTop + textHeight - imageHeight) {
					// Apply "sticky" effect to the image if text is longer
					image.style.transform = `translate3d(0, ${ relativeScroll }px, 0)`;
				} else {
					// Standard parallax effect
					const parallaxOffset = relativeScroll * 0.5; // Adjust effect intensity
					image.style.transform = `translate3d(0, ${ parallaxOffset }px, 0)`;
				}
			});
		};

		window.addEventListener('scroll', updateParallax);
		window.addEventListener('resize', () => {
			updateParallax();
			resetStyles(); // Reset styles on resize
		});

		resetStyles(); // Initialise with reset styles
	}

	function galleries(_sel) {
		if (_sel.children.length > 1) {
			const highlightedGallery = _sel;
			let imageIndex = 0;
			let touchstartX = 0;
			let touchendX = 0;

			// Wrap the gallery
			const wrapper = document.createElement('div');
			wrapper.className = 'wp-block-gallery__highlighted-gallery';
			highlightedGallery.parentNode.insertBefore(wrapper, highlightedGallery);
			wrapper.appendChild(highlightedGallery);

			// Clone the first child
			const firstChildClone = highlightedGallery.children[ 0 ].cloneNode(true);
			firstChildClone.className += ' highlighted-gallery__selected-image';
			const container = document.createElement('div');
			container.className = 'highlighted-gallery__selected-image-container';
			wrapper.insertBefore(container, highlightedGallery);
			container.appendChild(firstChildClone);

			const highlightedGalleryInner = container;

			const figcaptions = highlightedGalleryInner.querySelectorAll('figcaption');
			figcaptions.forEach((figcaption) => {
				figcaption.classList.add('wp-block-button', 'wp-block-button--secondary', 'button--play', 'farlo-ui-lightbox__toggle');
				figcaption.children.forEach((child) => child.classList.add('wp-block-button__link'));
				// Note: Implement `farloUiLightbox` equivalent if needed
			});

			if (highlightedGallery.children.length > 1) {
				const controlsDiv = document.createElement('div');
				controlsDiv.className = 'highlighted-gallery__controls';
				controlsDiv.innerHTML = '<button class="highlighted-gallery__controls-button highlighted-gallery__controls-button--prev"></button><button class="highlighted-gallery__controls-button highlighted-gallery__controls-button--next"></button>';
				highlightedGalleryInner.appendChild(controlsDiv);
			}

			function galleryItem(item) {
				item.classList.add('highlighted-gallery__item'); // Adjust as necessary
				item.addEventListener('click', function(e) {
					e.preventDefault();
					const childItem = e.currentTarget;

					if (childItem.classList.contains('highlighted-gallery__item--active')) {
						return;
					}

					childItem.classList.add('highlighted-gallery__item--active');
					Array.from(childItem.parentNode.children).forEach((sibling) => sibling !== childItem && sibling.classList.remove('highlighted-gallery__item--active'));

					const selectedImageDiv = highlightedGalleryInner.querySelector('.highlighted-gallery__selected-image');
					selectedImageDiv.innerHTML = '';
					selectedImageDiv.appendChild(childItem.cloneNode(true));

					const figcaptions = highlightedGalleryInner.querySelectorAll('figcaption');
					figcaptions.forEach((figcaption) => {
						figcaption.classList.add('wp-block-button', 'wp-block-button--secondary', 'button--play', 'farlo-ui-lightbox__toggle');
						figcaption.children.forEach((child) => child.classList.add('wp-block-button__link'));
						// Note: Implement `farloUiLightbox` equivalent if needed
					});

					imageIndex = Array.prototype.indexOf.call(highlightedGallery.children, childItem);
				});
			}

			function handleSwipe() {
				if (touchendX < touchstartX) {
					// Swipe Left - Next Image
					document.querySelector('.highlighted-gallery__controls-button--next').click();
				}
				if (touchendX > touchstartX) {
					// Swipe Right - Previous Image
					document.querySelector('.highlighted-gallery__controls-button--prev').click();
				}
			}

			document.querySelector('.wp-block-gallery__highlighted-gallery').addEventListener('click', function(e) {
				if (!e.target.classList.contains('highlighted-gallery__controls-button')) {
					return;
				}

				e.preventDefault();

				if (e.target.classList.contains('highlighted-gallery__controls-button--next') && imageIndex === highlightedGallery.children.length - 1) {
					imageIndex = -1;
				}

				if (e.target.classList.contains('highlighted-gallery__controls-button--prev') && imageIndex === 0) {
					imageIndex = highlightedGallery.children.length;
				}

				imageIndex += e.target.classList.contains('highlighted-gallery__controls-button--prev') ? -1 : 1;

				if (highlightedGallery.children[ imageIndex ]) {
					highlightedGallery.children[ imageIndex ].click();
				}
			});

			container.addEventListener('touchstart', (e) => {
				touchstartX = e.changedTouches[ 0 ].screenX;
			});

			container.addEventListener('touchend', (e) => {
				touchendX = e.changedTouches[ 0 ].screenX;
				handleSwipe();
			});

			container.nextElementSibling.style.maxHeight = container.querySelector('.wp-block-image').offsetHeight + 'px';

			Array.from(highlightedGallery.children).forEach(galleryItem);
		}
	}

	history.pushState = function(state) {
		if (typeof history.onpushstate === 'function') {
			history.onpushstate({ state });
		}
		return pushState.apply(history, arguments);
	};

	document.addEventListener('DOMContentLoaded', () => {
		if (document.querySelector('.site-navigation__navicon')) {
			navicon();
		}

		if (document.querySelector('.site-navigation__sub-menu')) {
			document.querySelectorAll('.site-navigation__sub-menu').forEach((_sel) => {
				navigation(_sel);
			});
		}

		if (document.querySelector('.site-farlo-ui-biscuit-banner')) {
			cookieCompliance();
		}

		document.querySelectorAll('a[href*="#"]').forEach((_sel) => {
			smoothScroll(_sel);
		});

		if (document.querySelector('.site-faqs')) {
			faqs();
		}

		if (document.querySelector('.farlo-ui-crm--inline')) {
			document.querySelectorAll('[farlo-ui="crm"]').forEach((_sel) => {
				farloUiCrmSignup(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-crm__toggle')) {
			const buttons = document.querySelectorAll('.farlo-ui-crm__toggle');
			const crmBlocks = document.querySelectorAll('.farlo-ui-crm[farlo-ui="crm"]');

			buttons.forEach(function(button) {
				let closestCrmBlock = null;
				let closestDistance = Infinity;

				crmBlocks.forEach(function(block) {
					const distance = button.getBoundingClientRect().top - block.getBoundingClientRect().top;
					if (distance > 0 && distance < closestDistance) {
						closestDistance = distance;
						closestCrmBlock = block;
					}
				});

				if (closestCrmBlock) {
					const crmId = closestCrmBlock.getAttribute('data-crm-id');
					button.setAttribute('data-crm-button-for', crmId);
				}
			});

			buttons.forEach((_sel) => {
				_sel.addEventListener('click', (e) => {
					e.preventDefault();
					e.stopImmediatePropagation();
					farloUiCrmSignup(e);
				});
			});
		}

		if (document.querySelector('.site-farlo-ui-ticket-calendar')) {
			document.querySelectorAll('[farlo-ui="calendar"]').forEach((_sel) => {
				new FarloUiTicketCalendar(_sel);
			});
		}

		if (document.querySelector('select')) {
			document.querySelectorAll('select').forEach((_sel) => {
				new FarloUiSelectBox(_sel);
			});
		}

		if (document.querySelector('.site-farlo-ui-lightbox__toggle')) {
			document.querySelectorAll('.site-farlo-ui-lightbox__toggle').forEach((_sel) => {
				new FarloUiLightbox(_sel);
			});
		}

		if (document.querySelector('.site-farlo-ui-revolver-carousel')) {
			document.querySelectorAll('[farlo-ui="carousel"]').forEach((_sel) => {
				new FarloUiRevolverCarousel(_sel);
			});
		}
	});

	window.addEventListener('load', () => {
		if (document.querySelector('.site-parallax')) {
			parallaxSections();
		}

		if (document.querySelector('.wp-block-gallery')) {
			document.querySelectorAll('.wp-block-gallery.columns-1').forEach((_sel) => {
				galleries(_sel);
			});
		}
	});

	if (typeof navigator !== 'undefined') {
		navigator.serviceWorker.getRegistrations().then(function(registrations) {
			for (const registration of registrations) {
				registration.unregister();
			}
		});
	}
})(document, window, history);
